<template>
  <f7-page name="oeb-resumen-anual" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link back icon-f7="arrow_left"></f7-link>
        <div class="btn-info" @click.stop="togglePanelInfo" :class="{'btn-info-activo': popupInfo}"><span>i</span></div>
      </f7-nav-left>
      <f7-nav-title>Resumen Anual OEB — Producción</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="zoomOut" style="font-size:12px;min-width:20px">−</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="cargarDatos" title="Actualizar"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #26 · Ya no dice "En vivo". El resumen si se compone en la peticion a partir de las fichas
         mensuales y los objetivos del anio, pero las CIFRAS que llevan dentro esas fichas entran
         por "Actualizar cifras" y por el cron de 30 minutos y pueden ser de hace dias: las dos
         frases juntas se contradecian. Ver selloCifras para por que se enseña una sola fecha de
         las doce.
         Mientras carga no se enseña: al pulsar Actualizar los datos del mismo anio se conservan
         hasta que responde la peticion (#769), y lo que se esta recalculando es justo esa
         antiguedad; con la conexion lenta se ve varios segundos. -->
    <div class="sello-datos-bar">
      <sello-datos v-if="!cargando" :estado="selloCifras.estado" :fecha="selloCifras.fecha"
        nota="Cifras TPC, la carga más antigua del año" />
    </div>
    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
      <div class="contenido-resumen" :style="{ fontSize: (zoom * 0.12) + 'px' }">
      <!-- SELECTOR DE AÑO -->
      <div class="mes-selector">
        <f7-link @click="anioSeleccionado--; cambiarAnio(anioSeleccionado)" icon-f7="chevron_left"></f7-link>
        <span class="mes-nombre">{{ anioSeleccionado }}</span>
        <f7-link @click="anioSeleccionado++; cambiarAnio(anioSeleccionado)" icon-f7="chevron_right"></f7-link>
      </div>

      <!-- LOADING -->
      <f7-block v-if="cargando" class="text-align-center"><f7-preloader></f7-preloader></f7-block>

      <!-- TABLA -->
      <div class="tabla-anual-scroll" v-if="datos && datos.personas && datos.personas.length && !cargando">
        <table class="tabla-anual">
          <thead>
            <tr>
              <th class="col-sticky col-codigo">Cód.</th>
              <th class="col-mes" v-for="m in 12" :key="'h-'+m">{{ nombresMes[m-1] }}</th>
              <th class="col-total">TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in datos.personas" :key="p.codigoPersonal" class="fila-persona"
              @click="togglePersona(p.codigoPersonal)"
              :class="{'fila-seleccionada': personasSeleccionadas.indexOf(p.codigoPersonal) > -1}">
              <td class="col-sticky col-codigo"><strong>{{ p.codigoPersonal }}</strong></td>
              <td class="col-mes" v-for="m in p.meses" :key="'c-'+m.mes" :style="colorCelda(m)">
                {{ m.hayFicha ? formatCorto(m.progresion) : '—' }}
              </td>
              <td class="col-total" :style="colorTotal(p)"><strong>{{ formatCorto(p.totalAnio) }}</strong></td>
            </tr>
          </tbody>
          <tfoot>
            <!-- TOTAL progresión -->
            <tr class="fila-totales">
              <td class="col-sticky col-codigo"><strong>TOTAL</strong></td>
              <td class="col-mes" v-for="tm in datos.totalesMes" :key="'tp-'+tm.mes" :style="colorCelda(tm)">
                <strong>{{ tm.hayFicha ? formatCorto(tm.progresion) : '—' }}</strong>
              </td>
              <td class="col-total"><strong>{{ formatCorto(datos.totalAnio.progresion) }}</strong></td>
            </tr>
            <!-- OBJETIVO -->
            <tr class="fila-obj">
              <td class="col-sticky col-codigo">OBJETIVO</td>
              <td class="col-mes" v-for="tm in datos.totalesMes" :key="'to-'+tm.mes">
                {{ tm.hayFicha ? formatCorto(tm.objetivo) : '—' }}
              </td>
              <td class="col-total">{{ formatCorto(datos.totalAnio.objetivo) }}</td>
            </tr>
            <!-- DIFERENCIA -->
            <tr class="fila-dif">
              <td class="col-sticky col-codigo">DIFERENCIA</td>
              <td class="col-mes" v-for="tm in datos.totalesMes" :key="'td-'+tm.mes"
                  :class="(tm.progresion - tm.objetivo) >= 0 ? 'valor-positivo' : 'valor-negativo'">
                {{ tm.hayFicha ? formatConSigno(tm.progresion - tm.objetivo) : '—' }}
              </td>
              <td class="col-total" :class="(datos.totalAnio.progresion - datos.totalAnio.objetivo) >= 0 ? 'valor-positivo' : 'valor-negativo'">
                <strong>{{ formatConSigno(datos.totalAnio.progresion - datos.totalAnio.objetivo) }}</strong>
              </td>
            </tr>
            <!-- % CUMPLIMIENTO -->
            <tr class="fila-pct">
              <td class="col-sticky col-codigo">% CUMP.</td>
              <td class="col-mes" v-for="tm in datos.totalesMes" :key="'tpct-'+tm.mes">
                <span v-if="tm.hayFicha" class="badge-estado" :class="'estado-' + estadoColor(tm.porcentaje)">{{ tm.porcentaje.toFixed(1) }}%</span>
                <span v-else>—</span>
              </td>
              <td class="col-total">
                <span class="badge-estado" :class="'estado-' + estadoColor(datos.totalAnio.porcentaje)">{{ datos.totalAnio.porcentaje.toFixed(1) }}%</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- GRÁFICO -->
      <div v-if="datos && datos.personas && datos.personas.length && !cargando">
        <div style="padding:0.4em 0.8em;font-size:0.8em;color:#7c8db0">
          <span v-if="personasSeleccionadas.length === 0">Mostrando: Total equipo. Pulsa en una persona para filtrar.</span>
          <span v-else>
            Mostrando: {{ personasSeleccionadas.join(', ') }}
            <span style="color:#185FA5;cursor:pointer;margin-left:8px" @click="personasSeleccionadas = []">Limpiar</span>
          </span>
        </div>
        <div style="display:flex;gap:1.2em;padding:0 0.8em;font-size:0.75em;color:#7c8db0;margin-bottom:0.3em">
          <span style="display:flex;align-items:center;gap:4px"><span style="width:10px;height:10px;border-radius:2px;background:#185FA5"></span>Resultado</span>
          <span style="display:flex;align-items:center;gap:4px"><span style="width:10px;height:10px;border-radius:2px;background:rgba(24,95,165,0.25)"></span>Objetivo</span>
        </div>
        <div style="position:relative;height:220px;padding:0 0.8em">
          <canvas ref="chartResumenAnual"></canvas>
        </div>
      </div>

      <!-- SIN DATOS -->
      <f7-block v-if="!cargando && (!datos || !datos.personas || !datos.personas.length)" class="text-align-center">
        <p>No hay fichas para {{ anio }}</p>
      </f7-block>
      </div>
    </f7-page-content>

    <!-- POPUP GUÍA DE USO -->
    <f7-popup :opened="popupInfo" @popup:close="fullscreen = false; popupInfo = false" class="ct-popup" :style="fullscreen ? '--f7-popup-tablet-width:95vw;--f7-popup-tablet-height:95vh' : ''">
      <f7-page :page-content="false">
        <f7-navbar title="Guía de uso" style="display:none"></f7-navbar>
        <div class="ct-hdr" style="background:linear-gradient(135deg,#0F6E56,#27ae80)">
          <div class="ct-hdr-top">
            <div class="ct-hdr-left">
              <span class="ct-hdr-ico">📊</span>
              <div><div class="ct-hdr-title">Guía de uso</div><div class="ct-hdr-sub">RESUMEN ANUAL OEB</div></div>
            </div>
            <div class="ct-hdr-right">
              <span class="ct-hdr-badge">{{ instFiltradas.length }} instrucciones</span>
              <button class="ct-hdr-add" @click="nuevaInst">+</button>
              <button class="ct-hdr-close" @click="fullscreen = !fullscreen">{{ fullscreen ? '⇖' : '⛶' }}</button>
              <button class="ct-hdr-close" @click="fullscreen = false; popupInfo = false">✕</button>
            </div>
          </div>
          <div class="ct-search-wrap">
            <span class="ct-search-ico">🔍</span>
            <input class="ct-search" type="text" placeholder="Buscar instrucciones..." v-model="busquedaInst">
            <button v-if="busquedaInst" class="ct-search-x" @click="busquedaInst = ''">✕</button>
          </div>
        </div>
        <f7-page-content class="ct-body">
          <div v-if="instFiltradas.length" class="ct-counter">{{ instFiltradas.length }} instrucciones</div>
          <div v-if="!instFiltradas.length" class="ct-empty"><span style="font-size:32px;opacity:.3">📊</span><p>Sin instrucciones. Pulsa + para crear.</p></div>
          <div v-for="(inst, idx) in instFiltradas" :key="inst.id" class="ct-card" style="border-left-color:#0F6E56"
            draggable="true" @dragstart="draggingInst = idx" @dragover.prevent @drop="dropInst(idx)">
            <div class="ct-card-hdr" @click="expandedInst === inst.id ? expandedInst = null : expandedInst = inst.id">
              <span class="ct-card-num" style="background:#0F6E56">{{ idx + 1 }}</span>
              <div class="ct-card-title-area"><div class="ct-card-title">{{ inst.titulo }}</div></div>
              <span class="ct-card-chev">{{ expandedInst === inst.id ? '▲' : '▼' }}</span>
            </div>
            <div v-if="expandedInst === inst.id" class="ct-card-body">
              <template v-if="inst._editando">
                <div class="ct-form-field"><label>Título</label><input type="text" v-model="inst.titulo"></div>
                <div class="ct-form-field"><label>Contenido</label><textarea v-model="inst.texto" rows="4"></textarea></div>
                <div class="ct-form-btns">
                  <button class="ct-fbtn ct-fbtn-ok" @click="guardarInst(inst)">Guardar</button>
                  <button class="ct-fbtn ct-fbtn-cancel" @click="inst._editando = false">Cancelar</button>
                </div>
              </template>
              <template v-else>
                <div class="ct-card-content">{{ inst.texto }}</div>
                <div class="ct-card-actions">
                  <button @click.stop="$set(inst, '_editando', true)">✏️ Editar</button>
                  <button @click.stop="eliminarInst(inst)">🗑️ Eliminar</button>
                </div>
              </template>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
/* Selector año (mismo estilo que mes-selector de control-cifras) */
.mes-selector { display:flex; align-items:center; justify-content:center; gap:1.2em; padding:0.3em 1em 0.2em; }
.mes-nombre { font-size:1.8em; font-weight:700; color:#1a2744; letter-spacing:-0.02em; }

.tabla-anual-scroll { overflow-x:auto; -webkit-overflow-scrolling:touch; border:1px solid #dde3ed; border-radius:0.67em; margin:0 0.67em; box-shadow:0 1px 6px rgba(0,0,0,0.04); background:white; }
.tabla-anual { border-collapse:collapse; font-size:0.92em; white-space:nowrap; width:100%; }
.tabla-anual thead th { background:#1a2744; color:#c8d3e5; padding:0.67em 0.5em; font-weight:600; font-size:0.83em; text-transform:uppercase; letter-spacing:0.04em; text-align:right; }
.tabla-anual thead th.col-codigo { text-align:left; color:white; }
.tabla-anual tbody td { padding:0.42em 0.5em; border-bottom:1px solid #eef0f5; text-align:right; color:#2d3748; }
.tabla-anual tbody tr:nth-child(even) { background:#fafbfd; }
.tabla-anual tbody tr:hover { background:#eef2f9 !important; }

.col-sticky { position:sticky; left:0; background:white; z-index:1; box-shadow:2px 0 8px rgba(0,0,0,0.06); }
thead .col-sticky { background:#1a2744; z-index:3; }
.fila-totales .col-sticky, .fila-obj .col-sticky, .fila-dif .col-sticky, .fila-pct .col-sticky { background:#eef1f7; }

.col-codigo { text-align:left !important; min-width:4.6em; font-weight:700; color:#1a2744; }
.col-mes { min-width:5em; }
.col-total { min-width:5.8em; font-weight:700; border-left:2px solid #c8d0de !important; }
thead .col-total { border-left:2px solid #3d5278 !important; }

.fila-totales td { background:#eef1f7; font-weight:700; padding:0.58em 0.5em; border-top:2px solid #c8d0de; color:#1a2744; }
.fila-obj td { background:#f5f7fa; font-size:0.83em; color:#7c8db0; padding:0.33em 0.5em; }
.fila-dif td { font-size:0.83em; padding:0.33em 0.5em; font-weight:500; }
.fila-pct td { font-size:0.83em; padding:0.33em 0.5em; border-bottom:2px solid #c8d0de; }

.badge-estado { display:inline-block; padding:0.17em 0.58em; border-radius:1.67em; font-weight:700; font-size:0.83em; }
.estado-MUY_BUENO { background:#D6EAF8; color:#1B4F72; }
.estado-BUENO { background:#D5F5E3; color:#0E6251; }
.estado-MALO { background:#FADBD8; color:#943126; }
.estado-MUY_MALO { background:#F1948A; color:#641E16; }

.valor-positivo { color:#0E6251 !important; font-weight:600; }
.valor-negativo { color:#B71C1C !important; font-weight:600; }

.fila-persona { cursor:pointer; }
.fila-seleccionada { background:#E6F1FB !important; font-weight:600; }
.fila-seleccionada .col-sticky { background:#E6F1FB !important; }

/* Botón info + Popup guía */
.btn-info { width:24px;height:24px;border-radius:50%;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;cursor:pointer;border:1.5px solid #5DCAA5; }
.btn-info span { color:#5DCAA5;font-size:13px;font-weight:500;font-style:italic; }
.btn-info-activo { background:#5DCAA5 !important; }
.btn-info-activo span { color:#1a2744 !important; }
.ct-popup { --f7-popup-tablet-width:700px; }
.ct-hdr { padding:14px 16px 12px;flex-shrink:0; }
.ct-hdr-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:12px; }
.ct-hdr-left { display:flex;align-items:center;gap:10px; }
.ct-hdr-ico { font-size:24px; }
.ct-hdr-title { font-size:16px;font-weight:800;color:#fff; }
.ct-hdr-sub { font-size:10px;color:rgba(255,255,255,.6);margin-top:1px; }
.ct-hdr-right { display:flex;align-items:center;gap:6px; }
.ct-hdr-badge { background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff; }
.ct-hdr-add,.ct-hdr-close { width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center; }
.ct-hdr-add:hover,.ct-hdr-close:hover { background:rgba(255,255,255,.25); }
.ct-search-wrap { position:relative;display:flex;align-items:center; }
.ct-search-ico { position:absolute;left:10px;font-size:13px; }
.ct-search { width:100%;padding:9px 32px;border:none;border-radius:8px;font-size:13px;background:rgba(255,255,255,.9);color:#1e293b;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.1); }
.ct-search:focus { background:#fff; }
.ct-search-x { position:absolute;right:8px;background:none;border:none;color:#94a3b8;font-size:12px;cursor:pointer;padding:4px; }
.ct-body { background:linear-gradient(180deg,#f8fafc,#f0f2f5);padding:10px 14px !important; }
.ct-counter { font-size:11px;color:#64748b;font-weight:600;padding:4px 2px 8px; }
.ct-empty { text-align:center;padding:40px 20px;color:#94a3b8;font-size:12px; }
.ct-card { background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.05);overflow:hidden;cursor:grab; }
.ct-card:hover { box-shadow:0 3px 10px rgba(0,0,0,.08); }
.ct-card-hdr { display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer; }
.ct-card-num { width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;color:#fff;flex-shrink:0; }
.ct-card-title-area { flex:1;min-width:0; }
.ct-card-title { font-size:13px;font-weight:600;color:#1e293b;line-height:1.4; }
.ct-card-chev { font-size:10px;color:#94a3b8;flex-shrink:0; }
.ct-card-body { padding:0 12px 12px;border-top:1px solid #f1f5f9; }
.ct-card-content { font-size:12.5px;line-height:1.6;color:#334155;padding:10px 4px; }
.ct-card-actions { display:flex;gap:4px;padding-top:8px;border-top:1px solid #f1f5f9; }
.ct-card-actions button { background:none;border:1px solid #e2e8f0;border-radius:6px;padding:4px 10px;font-size:10px;cursor:pointer;color:#475569; }
.ct-card-actions button:hover { background:#f1f5f9; }
.ct-form-field { display:flex;flex-direction:column;gap:3px;margin-bottom:8px; }
.ct-form-field label { font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase; }
.ct-form-field input,.ct-form-field textarea { padding:8px 10px;border:1.5px solid #d1d9e0;border-radius:6px;font-size:12px;font-family:inherit;color:#1e293b;outline:none;resize:vertical; }
.ct-form-field input:focus,.ct-form-field textarea:focus { border-color:#0F6E56; }
.ct-form-btns { display:flex;gap:6px; }
.ct-fbtn { padding:7px 16px;border:none;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit; }
.ct-fbtn-ok { background:#0F6E56;color:#fff; }
.ct-fbtn-ok:hover { background:#0a4f42; }
.ct-fbtn-cancel { background:#f1f5f9;color:#475569;border:1px solid #e2e8f0; }
.ct-fbtn-cancel:hover { background:#e2e8f0; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
/* #26 · Con alto reservado: el sello se oculta mientras carga y sin esto la tabla daba un salto
   cada vez que se cambiaba de anio. */
.sello-datos-bar { padding: 6px 16px 0; min-height: 30px; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import SelloDatos from '../../components/SelloDatos.vue';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';

export default {
  components: { SelloDatos },
  data() {
    return {
      anio: new Date().getFullYear(),
      anioSeleccionado: new Date().getFullYear(),
      zoom: 100,
      datos: null,
      cargando: false,
      personasSeleccionadas: [],
      chartReady: false,
      chartInstance: null,
      popupInfo: false,
      fullscreen: false,
      instrucciones: [],
      busquedaInst: '',
      expandedInst: null,
      draggingInst: null,
      nombresMes: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
    };
  },
  computed: {
    instFiltradas: function() {
      var q = (this.busquedaInst || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) { return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1; });
    },
    /**
     * #26 · De cuándo son las cifras TPC de esta tabla. La tabla resume doce fichas y cada una
     * carga sus cifras por su cuenta, así que se enseña la carga MÁS ANTIGUA: es la única fecha
     * que se puede afirmar del conjunto —ninguna cifra de la tabla es más vieja que ella—, y
     * enseñar la más reciente haría pasar por fresca una columna de hace meses.
     *
     * Si un solo mes con ficha no tiene marca (ficha anterior a #26, que no se rellena hacia
     * atrás) no se enseña ninguna fecha: podría haber cifras más viejas que la más antigua
     * conocida, y entonces la fecha mentiría. "No se sabe" es la respuesta cierta.
     */
    selloCifras: function() {
      var meses = (this.datos && this.datos.totalesMes) || [];
      var masAntigua = null;
      for (var i = 0; i < meses.length; i++) {
        if (!meses[i].hayFicha) continue;
        var t = new Date(meses[i].cifrasTpcCargadasEn).getTime();
        if (!meses[i].cifrasTpcCargadasEn || isNaN(t)) return { estado: 'desconocido', fecha: null };
        if (masAntigua === null || t < masAntigua.t) masAntigua = { t: t, valor: meses[i].cifrasTpcCargadasEn };
      }
      if (masAntigua === null) return { estado: 'desconocido', fecha: null };
      return { estado: 'fecha', fecha: masAntigua.valor };
    },
    datosGrafico: function() {
      if (!this.datos || !this.datos.personas) return { resultados: [], objetivos: [] };
      var self = this;
      var resultados = [0,0,0,0,0,0,0,0,0,0,0,0];
      var objetivos = [0,0,0,0,0,0,0,0,0,0,0,0];
      var personas = self.datos.personas;
      if (self.personasSeleccionadas.length > 0) {
        personas = personas.filter(function(p) { return self.personasSeleccionadas.indexOf(p.codigoPersonal) > -1; });
      }
      personas.forEach(function(p) {
        if (p.meses) {
          p.meses.forEach(function(m) {
            resultados[m.mes - 1] += (m.progresion || 0);
            objetivos[m.mes - 1] += (m.objetivo || 0);
          });
        }
      });
      return { resultados: resultados, objetivos: objetivos };
    }
  },
  // #769 · El gráfico se dibuja tras el repintado: su canvas cuelga del mismo v-if que la tabla,
  // y al cambiar de año el carril vacía `datos` y lo quita del DOM. Cuando llega el año nuevo estos
  // watchers corren ANTES de que Vue lo vuelva a crear, y sin esperar no hay canvas donde pintar.
  watch: {
    datosGrafico: { handler: function() { this.renderizarTrasRepintar(); }, deep: true },
    chartReady: function(val) { if (val) this.renderizarTrasRepintar(); }
  },
  // #769 · El año va por el carril común de la #472. La tabla ya se escondía mientras carga, pero
  // la respuesta de un año anterior que llegaba tarde apagaba el «cargando» con la vigente en
  // vuelo y, si llegaba la última, se quedaba pintada —con su gráfico— bajo el año nuevo.
  created: function() {
    const self = this;
    self.carrilAnio = carrilPeticiones({
      deAhora: function() { return [self.anio]; },
      vaciar: function() { self.datos = null; },
      cargando: function(si) { self.cargando = si; }
    });
  },
  beforeDestroy: function() {
    this.carrilAnio.invalidar();
    if (this.chartInstance) { this.chartInstance.destroy(); this.chartInstance = null; }
  },
  methods: {
    onPageInit() {
      var self = this;
      if (!window.Chart) {
        var script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.js';
        script.onload = function() { self.chartReady = true; };
        document.head.appendChild(script);
      } else { self.chartReady = true; }
      self.cargarDatos();
      self.cargarInstrucciones();
    },
    cambiarAnio(a) { this.anio = a; this.anioSeleccionado = a; this.cargarDatos(); },
    zoomIn() { this.zoom = Math.min(150, this.zoom + 5); },
    zoomOut() { this.zoom = Math.max(40, this.zoom - 5); },
    cargarDatos() {
      var self = this;
      self.carrilAnio.lanzar(Oeb.getResumenAnual(self.anio), {
        exito: function(res) { self.datos = unwrapDto(res) || null; },
        limpiar: function() { self.datos = null; }
      });
    },
    colorCelda(m) {
      if (!m.hayFicha || !m.objetivo || m.objetivo <= 0 || !m.progresion) return {};
      var pct = (m.progresion / m.objetivo) * 100;
      if (pct >= 105) return { background: '#D6EAF8', color: '#1B4F72' };
      if (pct >= 100) return { background: '#D5F5E3', color: '#0E6251' };
      if (pct >= 95) return { background: '#FADBD8', color: '#943126' };
      return { background: '#F1948A', color: '#641E16' };
    },
    colorTotal(p) {
      if (!p.objetivoAnio || p.objetivoAnio <= 0 || !p.totalAnio) return {};
      var pct = (p.totalAnio / p.objetivoAnio) * 100;
      if (pct >= 105) return { background: '#D6EAF8', color: '#1B4F72' };
      if (pct >= 100) return { background: '#D5F5E3', color: '#0E6251' };
      if (pct >= 95) return { background: '#FADBD8', color: '#943126' };
      return { background: '#F1948A', color: '#641E16' };
    },
    estadoColor(pct) {
      if (pct == null) return 'MUY_MALO';
      if (pct > 105) return 'MUY_BUENO';
      if (pct >= 100) return 'BUENO';
      if (pct >= 95) return 'MALO';
      return 'MUY_MALO';
    },
    formatCorto(v) {
      if (v == null || v === 0) return '0';
      return Math.round(v).toLocaleString('es-ES');
    },
    formatConSigno(v) {
      if (v == null) return '0';
      var s = v >= 0 ? '+' : '';
      return s + Math.round(v).toLocaleString('es-ES');
    },
    // Instrucciones
    togglePanelInfo() {
      var self = this;
      self.popupInfo = !self.popupInfo;
      if (self.popupInfo && !self.instrucciones.length) {
        Oeb.inicializarInstrucciones('resumen-anual').then(function() { self.cargarInstrucciones(); });
      }
    },
    cargarInstrucciones() {
      var self = this;
      Oeb.getInstrucciones('resumen-anual').then(function(res) {
        self.instrucciones = (unwrapDto(res) || []).map(function(i) { i._editando = false; return i; });
      }).catch(function() {});
    },
    nuevaInst() {
      var self = this;
      Oeb.crearInstruccion({ pantalla: 'resumen-anual', titulo: 'Nueva instrucción', texto: 'Escribe aquí...', orden: self.instrucciones.length }).then(function(res) {
        if (unwrapDto(res)) { unwrapDto(res)._editando = true; self.instrucciones.push(unwrapDto(res)); self.expandedInst = unwrapDto(res).id; }
      });
    },
    guardarInst(inst) {
      var self = this;
      Oeb.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto }).then(function() {
        inst._editando = false;
        self.$f7.toast.create({ text: 'Instrucción guardada', position: 'top', closeTimeout: 2000 }).open();
      });
    },
    eliminarInst(inst) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        Oeb.eliminarInstruccion(inst.id).then(function() {
          self.instrucciones = self.instrucciones.filter(function(i) { return i.id !== inst.id; });
        });
      });
    },
    dropInst(idx) {
      var from = this.draggingInst;
      if (from === null || from === idx) return;
      var item = this.instrucciones.splice(from, 1)[0];
      this.instrucciones.splice(idx, 0, item);
      this.draggingInst = null;
      var ids = this.instrucciones.map(function(i) { return i.id; });
      Oeb.reordenarInstrucciones(ids);
    },
    togglePersona(codigo) {
      var idx = this.personasSeleccionadas.indexOf(codigo);
      if (idx === -1) this.personasSeleccionadas.push(codigo);
      else this.personasSeleccionadas.splice(idx, 1);
    },
    renderizarTrasRepintar() {
      const self = this;
      self.$nextTick(function() { self.renderizarGrafico(); });
    },
    renderizarGrafico() {
      if (!this.chartReady || !window.Chart || !this.$refs.chartResumenAnual) return;
      if (this.chartInstance) { this.chartInstance.destroy(); this.chartInstance = null; }
      var datos = this.datosGrafico;
      var meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      this.chartInstance = new window.Chart(this.$refs.chartResumenAnual, {
        type: 'bar',
        data: {
          labels: meses,
          datasets: [
            { label: 'Resultado', data: datos.resultados, backgroundColor: '#185FA5', borderRadius: 3, barPercentage: 0.85, categoryPercentage: 0.9, order: 1 },
            { label: 'Objetivo', data: datos.objetivos, backgroundColor: 'rgba(24,95,165,0.2)', borderColor: 'rgba(24,95,165,0.4)', borderWidth: 1, borderRadius: 3, barPercentage: 0.85, categoryPercentage: 0.9, order: 2 }
          ]
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { callbacks: { label: function(ctx) { return ctx.dataset.label + ': ' + Math.round(ctx.raw).toLocaleString('es-ES') + ' \u20AC'; } } } },
          scales: {
            y: { ticks: { callback: function(v) { return (v / 1000).toFixed(0) + 'k'; }, font: { size: 10 } }, grid: { color: 'rgba(0,0,0,0.06)' } },
            x: { ticks: { font: { size: 10 } }, grid: { display: false } }
          }
        }
      });
    },
  }
};
</script>
